import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
}: Theme) => ({
  paper: {},
  title: {
    marginBottom: '2rem',
    letterSpacing: 'normal',
  },
  description: {
    margin: 0,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    marginTop: '2rem',
    [breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
}));
